<providers-menu [isFullWidth]="fullWidth"></providers-menu>
<div class="main-widget" [ngClass]="collapseMenuFlagData ? 'fullwidth-menu' : ''">
  <router-outlet></router-outlet>
</div>